import InlineTabs from 'components/commons/inline-tabs'
import { Button } from 'avo-ui'
import Search from 'components/commons/search'
import Sort from 'components/commons/sort'
import PageLimit from 'components/commons/page-limit'
import icLinkExternal from 'assets/images/ic-link-external.svg'
import Table from 'components/commons/table'
import ModalConfirmation from 'components/commons/modal-confirmation'
import { useDispatch, useSelector } from 'react-redux'
import { setModal, setSelectedValue } from 'reducers/listReducer'
import ModalExport from 'components/commons/modal-export'
import DateRangePicker from 'components/commons/date-range-picker'

export const List = (props) => {
    const {
        dataList,
        isLoading,
        isLoadingConfirm,
        isLoadingExport,
        onExport,
        filter,
        isDateRange,
        rightButton,
        rightButtonConfirm,
        onClickItemHandler,
        query,
        onChangeQuery,
        onChangeTab,
        isShowOnSelectItem = true,
        isResetSelectedItem,
    } = props
    const dispatch = useDispatch()
    const { options, modal, selectedValue, confirmationMessage } = useSelector((state) => state.listReducer)

    const onSelectSort = (value) => {
        const splitSort = value?.split('-')
        onChangeQuery({ order_by: splitSort[0], order_type: splitSort[1] })
    }

    return (
        <div>
            {options?.tab.length > 0 && (
                <InlineTabs
                    options={options?.tab}
                    onChange={(tab) => onChangeTab(tab)}
                    activeTab={selectedValue?.tab}
                    className={'py-6'}
                />
            )}
            <div className={'px-9 py-4'}>
                <div className={'flex gap-3 flex-wrap justify-between'}>
                    <div className={'flex gap-3'}>
                        <Search value={query?.search} onSearch={(value) => onChangeQuery({ search: value, page: 1 })} />
                        {!!isDateRange && (
                            <DateRangePicker
                                value={query?.start_date ? [query?.start_date, query?.end_date] : []}
                                onChange={(value) =>
                                    onChangeQuery({ start_date: value[0], end_date: value[1], page: 1 })
                                }
                                format={'YYYY-MM-DD'}
                            />
                        )}
                        {options.sort.length > 0 && (
                            <Sort
                                options={options.sort}
                                value={`${query?.order_by}-${query?.order_type}`}
                                onSelect={(value) => onSelectSort(value)}
                            />
                        )}
                        {filter && filter()}
                        <PageLimit
                            value={query?.limit}
                            onSelect={(value) => onChangeQuery({ limit: value, page: 1 })}
                        />
                        {!!onExport && (
                            <Button
                                title={'Export'}
                                icon={icLinkExternal}
                                type={'outline'}
                                disabled={!dataList?.total_result}
                                onClick={() => dispatch(setModal({ export: true }))}
                            />
                        )}
                    </div>
                    <div>{!!rightButton && rightButton()}</div>
                </div>
                <Table
                    className='my-3'
                    name={options.table?.name}
                    columns={options.table?.column}
                    data={dataList?.result}
                    size={query?.limit}
                    currentPage={query?.page}
                    totalPage={dataList?.total_page}
                    totalResult={dataList?.total_result}
                    onSelectItem={
                        isShowOnSelectItem ? (ids) => dispatch(setSelectedValue({ selectedIds: ids })) : false
                    }
                    onChangePage={(value) => onChangeQuery({ page: value })}
                    onClickItem={(val) => onClickItemHandler(val)}
                    loading={isLoading}
                    isResetSelectedItem={isResetSelectedItem}
                />
                {modal?.confirm && (
                    <ModalConfirmation
                        show={modal?.confirm}
                        onHide={() => dispatch(setModal({ confirm: false }))}
                        description={confirmationMessage}
                        totalData={selectedValue?.selectedIds?.length}
                        isLoading={isLoadingConfirm}
                        onConfirm={rightButtonConfirm}
                    />
                )}
                {modal?.export && (
                    <ModalExport
                        show={modal?.export}
                        onHide={() => dispatch(setModal({ export: false }))}
                        description={'Are You Sure Export This?'}
                        totalData={selectedValue?.selectedIds?.length || dataList?.total_result}
                        isLoading={isLoadingExport}
                        onExport={onExport}
                    />
                )}
            </div>
        </div>
    )
}
